import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el pack después de comprar?',
    a: 'Acceso inmediato por email con link de descarga directa. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    q: '¿Necesito saber de astrología para usarlo?',
    a: 'No. Está diseñado para mamás sin ningún conocimiento previo. Solo necesitás la fecha de nacimiento de tu hijo. El sistema te guía paso a paso.'
  }, {
    q: '¿Sirve si mi hijo ya tiene más de 10 años?',
    a: 'Sí. Los tomos aplican desde los 2 hasta los 14 años. Cada guía indica las adaptaciones por edad.'
  }, {
    q: '¿Los 3 bonus están incluidos en las dos ofertas?',
    a: 'Sí. Los 3 bonus siempre están incluidos sin costo extra en ambas opciones.'
  }, {
    q: '¿Sirve si tengo más de un hijo?',
    a: 'Sí, y es especialmente poderoso en ese caso. Cada hijo tiene su propio elemento y su propio mapa. El sistema te enseña a leer a cada uno de forma individual.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Es un PDF de solo lectura diseñado para su uso personal. No está habilitada su edición ni redistribución.'
  }, {
    q: '¿Funciona si soy papá y no mamá?',
    a: 'Absolutamente. El sistema aplica a cualquier figura de crianza principal: mamá, papá, abuela o tutor.'
  }, {
    q: '¿Qué diferencia tiene con otros libros de crianza?',
    a: 'Ningún libro de crianza tradicional te habla del diseño único de TU hijo. Código Hijo no es crianza genérica: es el mapa específico de tu hijo basado en su naturaleza real.'
  }, {
    q: '¿Por qué elegir el Pack Completo con Crianza Pro?',
    a: 'Porque los 6 tomos te dan el conocimiento y Crianza Pro te da la velocidad de aplicación. Es la diferencia entre entender a tu hijo y transformar la dinámica familiar en semanas.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si no es lo que esperabas, te devolvemos el 100% sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper data-id="element-44">
      <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-burgundy mb-12" data-id="element-45">
        ❓ PREGUNTAS FRECUENTES
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-46">
        {faqs.map((faq, i) => <div key={i} className="bg-white rounded-2xl border border-dusty-rose/20 overflow-hidden shadow-sm" data-id="element-47">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-48">
              <span className="font-bold text-text-main pr-4" data-id="element-49">{faq.q}</span>
              {openIndex === i ? <ChevronUp className="text-burgundy shrink-0" size={20} data-id="element-50" /> : <ChevronDown className="text-text-main/40 shrink-0" size={20} data-id="element-51" />}
            </button>

            <AnimatePresence data-id="element-52">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-53">
                  <div className="p-6 pt-0 text-text-main/80 leading-relaxed border-t border-dusty-rose/10 mt-2 pt-4" data-id="element-54">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </SectionWrapper>;
}